<ion-app [ngClass]="isInitPage ? 'white': 'black'">
  <app-best-exercise-detail-component *ngIf="showExerciseDetail"
    (close)="closeExerciseDetail()"
    #exerciseDetail>
  </app-best-exercise-detail-component>

  <ion-content [ngClass]="isInitPage ? 'white': 'black'">
    <div *ngIf="aside==EViewerAsideEnum.HELP" class="cont-info">
      <a class="close-info" (click)="changeRightContent(EViewerAsideEnum.CLOSE_HELP)">
        <img src="./../assets/images/SVG/close_light.svg" />
        {{ 'cerrar' | translate }}
      </a>
      <app-info-box-component *ngFor="let infoBox of helpViewer"
        [name]="infoBox.name"
        [type]="infoBox.type"
        [class]="infoBox.class"
        (change)="changeViewSlider($event)">
      </app-info-box-component>
    </div>

    <header id="main_header" *ngIf="!isInitPage && hasHeader">
        <img src="../../assets/images/SVG/wincoPro_wh_txt.svg" class="main-logo">

        <div class="menu">
          <div *ngIf="hasMenuAdmin" class="cont-menu">
            <nav>
              <a *ngFor="let menu of menus.administration"
                  [routerLink]="menu.link"
                  [class.hidden]="menu.hidden"
                  [class.selected]="menu.selected">
                <span>{{ menu.name | translate }}</span>
              </a>
            </nav>
          </div>

          <div *ngIf="isFlsPage" class="user">
            <app-circle-percent-component [auto]="true"
                                          [type]="ECirclePercentType.PERCENT"
                                          [percent]="studentProgress"
                                          [value]="studentProgress"
                                          color="cyan"></app-circle-percent-component>

            <div class="txt-user">
              <span>{{ 'progreso' | translate }}</span>
              <span>{{ 'ejercicios_fls' | translate }}</span>
            </div>
          </div>

          <div *ngIf="isMenuPage && userName" class="user">
            <div class="ic-user">{{ userAcronym }}</div>
            <div class="txt-user">
              <span>{{ 'bienvenido' | translate }}</span>
              <span>{{ userName }}</span>
            </div>
          </div>

          <a class="log-out" (click)="exit()">
            <img src="./../../assets/images/SVG/close_light.svg">
          </a>

        </div>
    </header>

    <nav *ngIf="!isInitPage && hasMenuNav" class="menu-left">
      <a *ngFor="let menu of menus.general"
          [routerLink]="menu.link || null"
          (click)="menu.click && menu.click(menu.parameter)"
          [class.hidden]="menu.hidden">
        <app-icon-button-component [icon]="menu.icon"
                                   [activeIcon]="menu.activeIcon"
                                   [label]="menu.name"
                                   [restBackground]="menu.restBackground"
                                   [variant]="menu.variant"
                                   [selected]="menu.selected">
        </app-icon-button-component>
      </a>
    </nav>

    <nav *ngIf="!isInitPage && hasMenuAction" class="menu-left menu-left-exercise">
      <a (click)="goOut()">
        <app-icon-button-component icon="icon_on_red"
                                   label="cancelar_entrenamiento"
                                   restBackground="var(--app-action-danger-background)">
        </app-icon-button-component>
      </a>

      <div class="separator" [class.hidden]="menus.separator.hidden"></div>
      <!-- <div class="separator" *ngIf="getMenuSelected('exercise/viewer') && cameraService.hasMultiCamera"></div> -->

      <a *ngFor="let menu of menus.cameras"
          (click)="menu.click && menu.click(menu.parameter)"
          [class.hidden]="menu.hidden">
        <app-icon-button-component [icon]="menu.icon"
                                   [activeIcon]="menu.activeIcon"
                                   [label]="menu.name"
                                   [restBackground]="menu.restBackground"
                                   [variant]="menu.variant"
                                   [selected]="menu.selected">
        </app-icon-button-component>
      </a>

      <div class="separator" [class.hidden]="menus.separator.hidden"></div>

      <a *ngFor="let menu of menus.aside"
          (click)="menu.click && menu.click(menu.parameter)"
          [class.hidden]="menu.hidden">
        <app-icon-button-component [icon]="menu.icon"
                                   [activeIcon]="menu.activeIcon"
                                   [label]="menu.name"
                                   [restBackground]="menu.restBackground"
                                   [variant]="menu.variant"
                                   [selected]="menu.selected">
        </app-icon-button-component>
      </a>
    </nav>

    <ion-router-outlet></ion-router-outlet>

    <footer id="main_footer" *ngIf="hasFooter && !isExercisePage" [class.footer-line]="typeFooter == TypeFooterEnum.LINE" [class.footer-auth]="typeFooter == TypeFooterEnum.AUTH">
      <div class="footer-claim">
        <div class="language-selector">
          <a class="selector selector-version" (click)="showInfoVersion()">
            <span>?</span>
          </a>
        </div>
        <div class="language-selector">
          <a class="selector" (click)="toggleLanguages($event)">
            <span>{{ nameLanguage }}</span>
            <img src="../../assets/images/SVG/icon_down_white_2.svg" class="arrow-down">
          </a>

          <ul class="languages" *ngIf="showLanguages" (click)="toggleLanguages($event)">
            <li *ngFor="let item of availableLanguages">
              <a class="selector" *ngIf="item.enabled" (click)="selectLanguage($event, item.code)"><span>{{ item.code | uppercase }}</span></a>
            </li>
          </ul>

          <span class="claim">{{ anno }} {{ 'derechos_reservados' | translate }}</span>
        </div>
      </div>
      <img src="../../assets/images/SVG/logo_medical_blanco.svg" class="logo-medical">
    </footer>

    <footer *ngIf="hasFooter && isExercisePage" class="black-footer">
      <ul *ngIf="userName">
        <li>
          <div class="icon icon-user"><span>{{ userAcronym }}</span></div>
          <div class="text">
            <span>{{ userName }}</span>
          </div>
        </li>
        <li>
          <div class="icon icon-image"><img src="./../assets/images/SVG/icon_clock_white.svg"></div>
          <div class="text">
            <span>{{ 'mejor_tiempo' | translate }}</span>
            <span>{{ betterTime }} min.</span>
          </div>
        </li>
        <li *ngIf="trackingActive">
          <div class="icon icon-image"><img src="./../assets/images/SVG/icon_dots_white.svg"></div>
          <div class="text">
            <span>{{ 'mejor_puntuacion' | translate }}</span>
            <span>{{ betterScore }}%</span>
          </div>
        </li>
      </ul>
      <div *ngIf="showResultExerciseButtons" class="buttons">
        <button (click)="goOut()" class="cancel">{{ 'salir' | translate | uppercase }}</button>
        <button (click)="repeatExercise()" class="submit">{{ 'repetir' | translate | uppercase }}</button>
      </div>
    </footer>

  </ion-content>
</ion-app>
